import moment from 'moment';
import { getData } from '@/components/report/service';
import { crudRequest2, getPlanDepartureCars, getActualDepartureCars } from '@/services/api';
import { chunkArrayInGroups } from '@/utils';
import { SqlBase } from '../Sql/common'
import { LoadQuery, DepartureQuery, DeliverSql3, DeliverSql4 } from '../Sql/Deliver';
import { getToDay } from '@/utils/date';

const dateRange = getToDay();

const paramsForm = {
  dateRange: [
    moment(dateRange[0]),
    moment(dateRange[1])
  ],
  centerFilter: '萧山分拨中心'
}

export default {
  namespace: 'forecastCenterDepartBoard',
  state: {
    tableOffsetHeight: 0,
    searchParams: { ...paramsForm },
    defualtDateFormat: 'YYYY-MM-DD 12:00:00',

    departureItem: [], //运力数据

    // 装载中
    dataList3: [],
    page3: 1,

    // 已发车
    alreadyList: [],
    notAlreadyList: [],
    alreadyPage: 1,
    notAlreadyPage: 1,
    dataList4: [],
    page4: 1,

    // 运力情况
    allDataList5: [], // 存储所有table list
    dataList5: [], // 当前页
    total5: 0,
    page5: 1,

    // 派送到达
    dataList6: [],
    page6: 1,
  },
  effects: {
    *getSelect({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: { ...payload },
      });
      yield put({ type: 'getLoadTable' });
      yield put({ type: 'getDepartureTable' });
      yield put({ type: 'getVolumesTable' });
      yield put({ type: 'getArriveTable' });

      yield put({ type: 'forecastCenterDepartBoardVolumes/getList' });
    },
    /**
     * 装载中 table
     * 1. 查询tms接口车辆信息获取车辆信息及任务号
     * 2. 通过任务号查选车辆票数/重量等相关数据
     * 3. 通过当前查询分拨运力数据(全局请求数据)匹配站点获取对应站点运力
    */
    *getLoadTable(_, { call, put, select }) {
      let query = yield select(({ forecastCenterDepartBoard }) => {
        const searchParams = forecastCenterDepartBoard.searchParams;
        const start = moment(searchParams.dateRange[0]).day();
        return {
          period: start === 0 ? 7 : start,
          departureCenter: searchParams.centerFilter,
          locationName: searchParams.centerFilter,
          startTime: moment(searchParams.dateRange[0]).format(forecastCenterDepartBoard.defualtDateFormat),
          endTime: moment(searchParams.dateRange[1]).format(forecastCenterDepartBoard.defualtDateFormat),
        }
      });
      const result = yield call(getPlanDepartureCars, {
        locationName: query.locationName,
        startTime: query.startTime,
        endTime: query.endTime,
      });
      const departure = yield call(crudRequest2, {
        period: query.period,
        departureCenter: query.departureCenter
      });
      const departureItem = departure.data && departure.data.length > 0 ? departure.data : []

      if (result && result.code === 1) {
        const data = result.data;
        const taskNos = [];
        data.forEach((item, index) => {
          item.index = index;
          const siteName = item.siteName.replace('分拨中心', '');
          let volumes = departureItem.find(item2 => siteName === item2.arrivalCenter);
          if (volumes) {
            item.volumes = volumes.volumes;
          }
          taskNos.push(item.taskNo)
        })
        const filter = {
          startDate: query.startTime,
          endDate: query.endTime,
          aggregators: SqlBase(),
        }
        const loadFilter = LoadQuery(taskNos, query.locationName);
        const results = yield call(getData, { ...filter, ...loadFilter });
        data.forEach(item => {
          const obj = results.find(item2 => item2.taskNo === item.taskNo);
          if (obj) {
            item.deliveryReceiptNo = obj.deliveryReceiptNo;
            item.goodsVolume = obj.goodsVolume;
            item.goodsWeight = obj.goodsWeight;
            item.piece = obj.piece;
            item.ticket = obj.ticket;
          }
        })
        yield put({
          type: 'update',
          payload: {
            dataList3: data,
          },
        });
      }
    },

    /**
     * 已发车 table
     * 1. 查询tms接口车辆信息获取车辆信息及任务号
     * 2. 通过任务号查选车辆票数/重量等相关数据
    */
    *getDepartureTable(_, { call, put, select }) {
      let query = yield select(({ forecastCenterDepartBoard }) => {
        const searchParams = forecastCenterDepartBoard.searchParams;
        return {
          locationName: searchParams.centerFilter,
          startTime: moment(searchParams.dateRange[0]).format(forecastCenterDepartBoard.defualtDateFormat),
          endTime: moment(searchParams.dateRange[1]).format(forecastCenterDepartBoard.defualtDateFormat),
        }
      });
      const result = yield call(getActualDepartureCars, query);
      if (result && result.code === 1) {
        const data = result.data;
        const taskNos = [];
        data.forEach((item, index) => {
          item.index = index;
          taskNos.push(item.taskNo)
        })
        const query2 = {
          startDate: query.startTime,
          endDate: query.endTime,
          aggregators: SqlBase(),
        }
        const filter = DepartureQuery(taskNos, query.locationName);
        const results = yield call(getData, { ...query2, ...filter });
        data.forEach(item => {
          const obj = results.find(item2 => item2.taskNo === item.taskNo);
          if (obj) {
            item.deliveryReceiptNo = obj.deliveryReceiptNo;
            item.goodsVolume = obj.goodsVolume;
            item.goodsWeight = obj.goodsWeight;
            item.piece = obj.piece;
            item.ticket = obj.ticket;
          }
        })
        const alreadyList = [];
        const notAlreadyList = [];
        data.forEach(item => {
          if (item.deliveryReceiptNo) {
            alreadyList.push(item);
          } else {
            notAlreadyList.push(item)
          }
        })
        yield put({
          type: 'update',
          payload: {
            alreadyList: alreadyList,
            notAlreadyList: notAlreadyList
          },
        });
      }
    },

    /**
     * 运力情况 table
     * 1. 获取实际发中转数据/其他分类数据
     * 2. 通过线路来匹配其他分类数据中线路是否是同一条数据
     * 3. 通过线路及下一站分拨获取当前线路运力
    */
    *getVolumesTable(_, { call, put, select }) {
      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoard }) => {
        const searchParams = forecastCenterDepartBoard.searchParams;
        return {
          simpleGranularity: 'all',
          startDate: moment(searchParams.dateRange[0]).format(forecastCenterDepartBoard.defualtDateFormat),
          endDate: moment(searchParams.dateRange[1]).format(forecastCenterDepartBoard.defualtDateFormat),
          aggregators: SqlBase(),
        }
      });
      const dataSql = DeliverSql3(centerFilter);
      const dataQuery = { ...query, ...dataSql[0] };
      const data = yield call(getData, dataQuery);

      const result = [];
      if (data && data.length > 0) {
        for (let i = 0; i < dataSql[1].length; i++) {
          const _d = yield call(getData, { ...query, ...dataSql[1][i] });
          result.push(_d || []);
        }
        data.forEach((item, index) => {
          item.index = index;
          result.forEach((item2, index2) => {
            const obj = item.trackLine !== 'undefined' && item2.find(item3 =>
              item.trackLine === item3.trackLine
            )
            if (obj) {
              item[`goodsVolume${index2 + 1}`] = obj.goodsVolume;
              item[`goodsWeight${index2 + 1}`] = obj.goodsWeight;
              item[`piece${index2 + 1}`] = obj.piece;
              item[`ticket${index2 + 1}`] = obj.ticket;
            }
          })
        })
        const newData = chunkArrayInGroups(data)
        yield put({
          type: 'setVolumesPage',
          payload: {
            page5: 1,
            data: newData,
          },
        });
        yield put({
          type: 'update',
          payload: {
            allDataList5: newData,
            total5: data.length
          },
        });
      }
    },
    /**
     * 运力情况 分页
    */
    *setVolumesPage({ payload }, { call, put, select }) {
      const { data, page5 } = payload;
      let query = yield select(({ forecastCenterDepartBoard }) => {
        const searchParams = forecastCenterDepartBoard.searchParams;
        const start = moment(searchParams.dateRange[0]).day();
        return {
          period: start === 0 ? 7 : start,
          page: page5 || forecastCenterDepartBoard.page5,
          allData: data || forecastCenterDepartBoard.allDataList5,
          departureItem: forecastCenterDepartBoard.departureItem
        }
      });
      const newData = query.allData[query.page - 1];
      for (let i = 0; i < newData.length; i++) {
        if (newData[i].trackLine) {
          const nextSite = newData[i].nextSite ? newData[i].nextSite.replace('分拨中心', '') : '';
          const departure = yield call(crudRequest2, {
            arrivalCenter: newData[i].nextSite,
            lineName: newData[i].trackLine,
            period: query.period,
          });
          const departureData = departure.data && departure.data.find(item =>
            item.arrivalCenter === nextSite
          )
          if (departureData) {
            newData[i].volumes = departureData.volumes;
          }
        }
      }
      yield put({
        type: 'update',
        payload: {
          page5: page5,
          dataList5: newData
        },
      });
    },

    /**
     * 派送到达 table
     * 1. 获取实际发出量 / 预计出发量数据
     * 2. 通过实际发出量目的网点来匹配预计出发量目的网点
    */
    *getArriveTable(_, { call, put, select }) {
      let centerFilter = yield select(({ forecastCenterDepartBoard }) => forecastCenterDepartBoard.searchParams.centerFilter);
      let query = yield select(({ forecastCenterDepartBoard }) => {
        const searchParams = forecastCenterDepartBoard.searchParams;
        return {
          simpleGranularity: 'all',
          startDate: moment(searchParams.dateRange[0]).format(forecastCenterDepartBoard.defualtDateFormat),
          endDate: moment(searchParams.dateRange[1]).format(forecastCenterDepartBoard.defualtDateFormat),
          aggregators: SqlBase(),
        }
      });
      const filter = DeliverSql4(centerFilter);
      // const arr = [];
      const data = yield call(getData, { ...query, ...filter[0] });
      const data2 = yield call(getData, { ...query, ...filter[1] });
      data && data.forEach((item, index) => {
        item.index = index;
        const result = data2 ? data2.find(item2 =>
          item.destinationSite === item2.destinationSite
        ) : null;
        if (result) {
          item.destinationSite2 = result.destinationSite;
          item.goodsVolume2 = result.goodsVolume;
          item.piece2 = result.piece;
          item.ticket2 = result.ticket;
          item.goodsWeight2 = result.goodsWeight;
        }
      })

      yield put({
        type: 'update',
        payload: {
          dataList6: data || []
        },
      });
    },
    /**
     * 获取当前分拨下运力数据
    */
    *getDeparture(_, { call, put, select }) {
      let query = yield select(({ forecastCenterDepartBoard }) => {
        const searchParams = forecastCenterDepartBoard.searchParams;
        const start = moment(searchParams.dateRange[0]).day();
        return {
          period: start === 0 ? 7 : start,
          departureCenter: searchParams.centerFilter
        }
      });
      const departure = yield call(crudRequest2, query);
      yield put({
        type: 'update',
        payload: {
          departureItem: departure.data && departure.data.length > 0 ? departure.data : []
        },
      });
    }
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
}